import React, { useState } from "react";
import MouseFooter from "../components/MouseFooter";
import "../styles/privacy-terms.css";
import { Link, useNavigate } from "react-router-dom";

export default function Privacy() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

    const goToSection = (e, id) => {
      e.preventDefault();
      navigate("/"); // go back to home first
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }, 100); // small delay so home page mounts
      setMenuOpen(false);
    };

  return (
    <>
      {/* Navbar */}
      <header className="navbar">
      <div className="logo">
      <Link
        to="/"
        onClick={() => {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }}
      >
        <img src="/ego.png" alt="Ego Blockchain Logo" className="logo-img" />
      </Link>
    </div>
        {/* Hamburger button */}
        <button
          className={`hamburger ${menuOpen ? "active" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* Nav links */}
        <nav className={`nav-links ${menuOpen ? "open" : ""}`}>
          <Link to="/download" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
            Download Ego Desktop
          </Link>
          <Link to="/blog" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
            Blog
          </Link>
          <Link to="/docs" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
            Docs
          </Link>
          <Link to="/egoscan" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
            EgoScan
          </Link>
          <Link to="/claim" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
            Claim EGOC
          </Link>
        </nav>
      </header>
            {/* Overlay (click to close) */}
            {menuOpen && (
        <div className="menu-overlay" onClick={() => setMenuOpen(false)} />
      )}

      {/* Page content */}
      <div className="policy-container">
        <h1>Privacy Policy of Ego Blockchain</h1>
        <p>
          <strong>Effective Date:</strong> November 12, 2024<br />
          <strong>Last Updated:</strong> June 18, 2026
        </p>

        <h2>1. Introduction</h2>
        <p>
          Ego Blockchain is committed to protecting your privacy while providing
          a secure and efficient platform. This Privacy Policy outlines our
          practices concerning the collection, use, disclosure, and protection
          of your information when using our services.
        </p>

        <h2>2. Information We Collect</h2>
        <p>
          <strong>Personal Information:</strong> We may collect personal
          information such as your name, email address, and contact details when
          you register for our services or interact with our platform.
        </p>
        <p>
          <strong>Technical Information:</strong> We collect technical data such
          as IP addresses, browser type, and device information to improve our
          services and ensure security.
        </p>
        <p>
          <strong>Usage Data:</strong> This includes information about your
          interactions with our platform, such as transaction history and
          activity logs.
        </p>

        <h2>3. How We Use Your Information</h2>
        <ul>
          <li>Provide and maintain our services</li>
          <li>Improve, personalize, and expand our platform</li>
          <li>Understand and analyze how you use our services</li>
          <li>Develop new products and features</li>
          <li>Communicate with you for support or marketing</li>
          <li>Prevent fraud and ensure security</li>
        </ul>

        <h2>4. Information Sharing and Disclosure</h2>
        <p>
          Ego Blockchain does not sell, trade, or transfer your personal
          information except:
        </p>
        <ul>
          <li>
            <strong>Service Providers:</strong> Vendors who perform services
            like payment processing and data analysis.
          </li>
          <li>
            <strong>Legal Compliance:</strong> If required by law or valid
            government request.
          </li>
        </ul>

        <h3>4.1 Third-Party Payment and Exchange Providers</h3>
        <p>
          Some features rely on independent third parties. When you use them,
          information is shared directly with that provider and handled under
          their own privacy policy, not ours. We do not control what they
          collect or how long they keep it.
        </p>
        <ul>
          <li>
            <strong>Crypto swaps — ChangeNow.</strong> Swaps between external
            assets (for example BTC to ETH) are executed by ChangeNow, not by
            Ego Blockchain. To create an exchange we send them the currency
            pair, the amount, and the destination wallet address the swap pays
            out to. ChangeNow receives your deposit and payout addresses and
            your IP address, and may require identity verification for certain
            transactions under its own AML obligations. We never take custody
            of the funds being swapped.
          </li>
          <li>
            <strong>Pre-sale card payments — Stripe.</strong> Card payments for
            the EGOC pre-sale are processed by Stripe. Card numbers are entered
            on Stripe&apos;s own hosted checkout page — they never pass through,
            and are never stored by, the Ego Desktop application or our servers.
            We receive only a payment reference, the amount, and whether the
            payment succeeded.
          </li>
          <li>
            <strong>Cryptocurrency purchases (when enabled).</strong> If we
            enable buying or selling crypto with a card or bank transfer, that
            is performed by a licensed third-party provider. You complete
            payment and any identity verification on the provider&apos;s own
            site. We supply only the destination wallet address and the
            requested amount, and we do not receive your identity documents or
            payment details.
          </li>
          <li>
            <strong>Market data.</strong> We request public price data from
            third-party APIs including CoinGecko. These requests expose your IP
            address to those providers.
          </li>
        </ul>
        <p>
          Please review the privacy policy of any provider before using these
          features. Their terms govern your relationship with them.
        </p>

        <h2>5. Security of Your Information</h2>
        <p>
          We use encryption, audits, and industry standards to protect your
          data.
        </p>

        <h2>6. Data Retention</h2>
        <p>
          We keep data only as long as necessary to comply with law and resolve
          disputes.
        </p>

        <h2>7. Your Rights and Choices</h2>
        <p>
          You may have rights such as access, rectification, erasure, and
          objection. Contact us to exercise them.
        </p>

        <h2>8. Third-Party Websites</h2>
        <p>
          This policy applies only to Ego Blockchain. Linked sites have their
          own policies.
        </p>

        <h2>9. Children’s Privacy</h2>
        <p>
          Not intended for under-16. If data is collected, we delete it.
        </p>

        <h2>10. Changes</h2>
        <p>
          We may update this policy and notify you of significant changes.
        </p>

        <h2>11. Ego Desktop — Storage, Location, and Node Participation</h2>
        <p>
          Ego Desktop is a peer-to-peer node application. When you install and
          run it, your device actively participates in the Ego network, and the
          following data may be used or processed:
        </p>
        <ul>
          <li>
            <strong>Background operation and start-up at login:</strong> Ego
            Desktop is designed to run continuously. On first launch it
            registers itself to start automatically when you sign in to your
            computer, and it starts minimised to the system tray rather than
            opening a window. Closing the window does not stop the application:
            it continues running in the background so your node stays connected,
            keeps serving stored data, and continues earning. While running it
            uses disk space, bandwidth and a share of CPU as described below.
            You can stop it at any time by choosing Quit from the tray icon
            menu, and you can remove it from start-up through your operating
            system&apos;s start-up settings; the application will not re-add
            itself once you have removed it.
          </li>
          <li>
            <strong>Automatic storage allocation:</strong> By default, Ego
            Desktop reserves and uses approximately <strong>10&nbsp;GB</strong>{" "}
            of your device&apos;s disk space to store encrypted shards and
            replicated data for the decentralized storage layer. This space is
            used automatically as part of normal operation and is how your device
            contributes to — and earns rewards from — the network. Data stored on
            your device is encrypted, and you can adjust or release this
            allocation in the app&apos;s storage settings.
          </li>
          <li>
            <strong>Location and coverage data:</strong> To support Proof of
            Coverage, Ego Desktop may collect approximate location and network
            connectivity and quality information (such as region, latency, and
            reachability) to verify that your node provides genuine network
            coverage and to calculate coverage rewards. Precise GPS location is
            not required for this purpose.
          </li>
          <li>
            <strong>Network identifiers:</strong> Operating a node necessarily
            exposes a public node address and public keys to other peers, and
            your IP address may be visible to the peers you connect to. This is
            inherent to peer-to-peer networks and is required for the network to
            function.
          </li>
          <li>
            <strong>Resource usage:</strong> The app uses network bandwidth and,
            where you enable it, CPU/GPU and additional storage to provide
            compute, hosting, and storage services to the network.
          </li>
        </ul>
        <p>
          On-chain data such as transactions, blocks, and node activity is public
          and permanent by design. Shielded (private) transfers hide the
          counterparties and amounts from public view, but the existence of the
          transaction is still recorded on-chain.
        </p>

        <h2>12. Contact Us</h2>
        <p>
          Email:{" "}
          <a href="mailto:support@egoblockchain.com">
            support@egoblockchain.com
          </a>
        </p>

        
      </div>
      <MouseFooter />
    </>
  );
}
